<template>
  <Transition name="slide-down">
    <div
      v-if="!workingHours.isCurrentBranchOpen.value"
      class="closed-global-banner"
    >
      <div class="closed-global-banner__container">
        <!-- Иконка часов -->
        <div class="closed-global-banner__icon">
          <Icon name="heroicons:clock" class="w-5 h-5" />
        </div>

        <!-- Основной контент -->
        <div class="closed-global-banner__content">
          <div class="closed-global-banner__title">
            <Icon name="heroicons:moon" class="w-4 h-4 inline mr-1" />
            Сейчас мы закрыты
          </div>

          <div v-if="workingHours.workingStatus.value.nextAction" class="closed-global-banner__subtitle">
            <Icon name="heroicons:sun" class="w-3.5 h-3.5 inline mr-1" />
            {{ workingHours.workingStatus.value.nextAction }}
          </div>

          <div v-else class="closed-global-banner__subtitle">
            <Icon name="heroicons:phone" class="w-3.5 h-3.5 inline mr-1" />
            Время работы уточняйте у администрации
          </div>
        </div>

        <!-- Иконка статуса -->
        <div class="closed-global-banner__action-icon">
          <Icon name="heroicons:information-circle" class="w-5 h-5" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useWorkingHours } from '@entities/institution'

const workingHours = useWorkingHours()
</script>

<style scoped lang="scss">
// Баннер «закрыто» — состояние warning из дизайн-системы (hui). Сплошной янтарный, без градиента/мерцания.
.closed-global-banner {
  @apply relative bg-hui-warning text-hui-warning-foreground;
  @apply border-b border-black/10 shadow-sm;

  &__container {
    @apply max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5;
    @apply flex items-center justify-between gap-3;
  }

  &__icon {
    @apply flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-full bg-black/10;
  }

  &__content {
    @apply flex-1 min-w-0 text-center;
  }

  &__title {
    @apply flex items-center justify-center text-sm font-bold mb-0.5;
  }

  &__subtitle {
    @apply flex items-center justify-center text-xs font-medium opacity-80;
  }

  &__action-icon {
    @apply flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-full bg-black/10;
  }
}

/* Анимация появления */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* Компактнее на мобильных */
@media (max-width: 640px) {
  .closed-global-banner {
    &__container {
      @apply px-3 py-2 gap-2;
    }

    &__icon,
    &__action-icon {
      @apply w-8 h-8;
    }
  }
}
</style>
